import { render, staticRenderFns } from "./UserClockWidget.vue?vue&type=template&id=032014f6&scoped=true&"
import script from "./UserClockWidget.ts?vue&type=script&lang=ts&"
export * from "./UserClockWidget.ts?vue&type=script&lang=ts&"
import style0 from "./UserClockWidget.vue?vue&type=style&index=0&id=032014f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032014f6",
  null
  
)

export default component.exports